import { getMetaError } from 'shared/functions';

import TreeMenu from 'components/TreeMenu';

export const FieldSkillTree = ({
  input,
  meta,
  menu,
  disabled,
  selectedOptions,
  showOnlySelected,
  showOnlyNonEmpty,
  isSkipped,
  onChange,
  onExpandGroup,
  getOptionLabel,
  isOption,
  isExpanded,
  getOptionId,
  getMenuId,
  getMenuLabel,
}) => {
  const error = getMetaError(meta);

  return (
    <div data-testid={input.name} key={input.name}>
      <TreeMenu
        menu={menu}
        disabled={disabled}
        selectedOptions={selectedOptions}
        showOnlySelected={showOnlySelected}
        showOnlyNonEmpty={showOnlyNonEmpty}
        isOption={isOption}
        isSkipped={isSkipped}
        isExpanded={isExpanded}
        getOptionId={getOptionId}
        getOptionLabel={getOptionLabel}
        getMenuId={getMenuId}
        getMenuLabel={getMenuLabel}
        onChange={onChange}
        onExpandGroup={onExpandGroup}
      />
      {error && <div className="errorMsg">{error}</div>}
    </div>
  );
};
